import { render, staticRenderFns } from "./container.vue?vue&type=template&id=8078e8f2&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"
import style0 from "./container.vue?vue&type=style&index=0&id=8078e8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8078e8f2",
  null
  
)

export default component.exports